<div class="black-stripe" [style]="{ '--color-fondo': configBloque?.color_fondo, '--color-texto-slick': configBloque?.color_texto, '--texto-weight': configBloque?.texto_negrita, '--container-height': resizable ? '2em' : 'unset', '--font-size': resizable ? '14px' : 'unset', '--btn-size': resizable ? '2em' : 'unset', '--secondary-flex': shouldShowArrows ? 'flex-start' : '' }">
  <div class="contenedor-menu-secundario">
    <ng-container *ngIf="showArrows">
      <app-keyboard-arrow-left class="btn-left" (click)="scroll('left')"></app-keyboard-arrow-left>
    </ng-container>
    <menu #secondary class="menu-secundario">
      <ng-container *ngFor="let item of subcanales; trackBy: trackByItem">
        <li class="slide">
          <a [ngClass]="{ 'decoracion-lateral': configBloque?.decoracion_lateral }" [routerLink]="[bloque_activo ? 'canal' : 'seccion', item?.idSubcanal, item?.nombreSubCanal | kebabCase]"> {{ item?.nombreSubCanal.length > 20 ? (item?.nombreSubCanal | slice: 0 : 20) + "..." : item?.nombreSubCanal }}</a>
        </li>
      </ng-container>
    </menu>
    <ng-container *ngIf="showArrows">
      <app-keyboard-arrow-right class="btn-right" (click)="scroll('right')"></app-keyboard-arrow-right>
    </ng-container>
  </div>
</div>
